import {h, Fragment} from "preact"
/*
    xxxxxxxxxxxxxxx Hybrid Category Page xxxxxxxxxxxxxxx

    This method is for displaying native Shopify PLPs 
    when no sorting and/or no filters are applied. Nosto takes
    over the page, only when sorting/filtering, hiding 
    the native Shopify PLP, then unhiding if all sorting and 
    filtering are removed.

    Reason: merchant needs to be able to pin more than 60 
    products for merchandising. 
        
    xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
*/

import { useAppState, useProductFilters, useSort } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { sortOptions } from "../../config"

import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import Products from "./Products"
import BottomToolbar from "./BottomToolbar"
import NoResults from "./NoResults"

export default function HybridCategory() {
    const appState = useAppState();
    const { response: { products }, loading } = appState;
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ expandedFacet, setExpandedFacet ] = useState(null);

    const { filters } = useProductFilters();
    
    const { activeSort } = useSort(sortOptions);
    const [ nostoActive, setNostoActive ] = useState(false);

    useEffect(() => {
        const bodyEl = document.querySelector('body');
        (sidebarOpen && bodyEl)
        ?   bodyEl.classList.add('overflow-hidden')
        :   bodyEl.classList.remove('overflow-hidden');
    }, [ sidebarOpen ]);
    
    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    };
    
    useEffect(() => {
        setNostoActive((filters?.length > 0 || activeSort !== 'score'))
    }, [ filters?.length , activeSort ]);
    
    useEffect(() => {
        const mainEl = document.getElementById('MainContent');
        if(mainEl) {
            mainEl.classList.toggle('ns-active', nostoActive);
            return () => mainEl.classList.remove('ns-active')
        }
    }, [ nostoActive ])

    return (
        <div class="ns-serp">
            {loading && !foundProducts ? (
                null
            ) : foundProducts ? (
                <>
                    <Sidebar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        expandedFacet={expandedFacet}
                    />
                    <div class="ns-serp-inner">
                        <Toolbar
                            toggleSidebar={toggleSidebar}
                            setExpandedFacet={setExpandedFacet}
                        />
                        {nostoActive && (
                            <>
                            <Products />
                            <BottomToolbar />
                            </>
                        )}
                    </div>
                </>
            ) : (
                <NoResults />
            )}
        </div>
    )
}
